<template>
    <Wrapper :showBack="false">
        <template #header>
            <van-icon name="checked" class="align-middle" color="#5AC73B" size="30" />
            {{ $t('revoke.hesitationSuccess') }}
        </template>
        <template #content>
            <i18n path="revoke.hesitationSuccessText0" tag="p" class="indent-2">
                <span place="time" class="submit-time">
                    {{ captchaData.commitShowTime }}
                </span>
                <span place="duration" class="duration">
                    {{ initialRevoke.hesitationDuration }}
                </span>
            </i18n>
            <br />
            <p class="indent-2">{{ $t('revoke.hesitationSuccessText1') }}</p>
        </template>
        <template #footer>
            <van-button v-if="showCancel" type="info" class="w-full" @click="handleClick">
                {{ $t('common.finished') }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button, Icon } from 'vant';
import { Platform } from '@/enums';
import Wrapper from './Wrapper.vue';

Vue.use(Button);
Vue.use(Icon);

export default {
    name: 'Success',
    components: {
        Wrapper,
    },
    props: {
        captchaData: {
            type: Object,
            required: true,
        },
        platform: {
            type: Number,
            required: true,
        },
        initialRevoke: {
            type: Object,
            required: true,
        },
    },
    created() {
        // 通知客户端，不显示右上角关闭按钮
        const data = JSON.stringify({
            code: -3,
            msg: 'Hide closeIcon',
            data: null,
        });
        if (this.platform === Platform.WebView) {
            window.RevokeCallback(data);
        } else if (this.platform === Platform.Android) {
            window.logoffJsBridge.RevokeCallback(data);
        }
    },
    computed: {
        showCancel() {
            return ![Platform.H5, Platform.Iframe].includes(this.platform);
        },
    },
    methods: {
        handleClick() {
            const data = JSON.stringify({
                code: 0,
                msg: 'Log off successful',
                data: this.captchaData,
            });

            try {
                if (this.platform === Platform.WebView) {
                    window.RevokeCallback(data);
                } else if (this.platform === Platform.Android) {
                    window.logoffJsBridge.RevokeCallback(data);
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
%color {
    color: var(--g-red-3);
}

.submit-time,
.duration {
    @extend %color;
}
</style>
